import React from 'react';
import styled from "styled-components";
import {postContractHTML} from "~/src/REST";
import SiteContext from '~/src/context/Site';
import regeneratorRuntime from "regenerator-runtime";

const IframeStyle = styled.iframe`
    width: 100%;
    border: none;
    overflow-x: hidden;
`;

const adjustFrameSize = (frame) => {
    frame.style.width = '100%';
    
    // Wait for content to load and then adjust height dynamically
    setTimeout(() => {
        const doc = frame.contentWindow.document;
        const body = doc.body;
        const html = doc.documentElement;
        
        // Get the full height including margins and padding
        const height = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );
        
        // Set iframe height
        frame.style.height = `${height + 20}px`;
        
        // Set body styles to prevent horizontal scrollbars only
        body.style.margin = '0';
        body.style.padding = '15px';
        body.style.overflowX = 'hidden';
        body.style.overflowY = 'visible';
    }, 100);
}

const writeDocument = ({contentDocument:doc},content) => {
    doc.open();
    doc.write(content);
    doc.close();
    
    // Add CSS to the document for proper formatting
    const style = doc.createElement('style');
    style.textContent = `
        body {
            margin: 0 !important;
            padding: 15px !important;
            overflow-x: hidden !important;
            overflow-y: visible !important;
            box-sizing: border-box !important;
            font-family: Arial, sans-serif !important;
            font-size: 14px !important;
            line-height: 1.4 !important;
        }
        * {
            box-sizing: border-box !important;
        }
        p, div, span, li {
            font-size: 14px !important;
        }
        h1, h2, h3, h4, h5, h6 {
            font-size: 16px !important;
            margin: 10px 0 !important;
        }
    `;
    doc.head.appendChild(style);
}

const Contract = ({index,contract_type}) => {
    const {authToken, language} = React.useContext(SiteContext)

    React.useEffect(async ()=>{
        let {__html} = await postContractHTML({contract_type, language, authToken})
        var iframe = document.getElementById(`${index}_${contract_type}`);
        writeDocument(iframe,__html)
        
        // Wait longer for content to render before adjusting size
        setTimeout(() => {
            adjustFrameSize(iframe)
        }, 500);
        
        // Adjust again after a longer delay to ensure all content is loaded
        setTimeout(() => {
            adjustFrameSize(iframe)
        }, 1000);
    },[authToken,language])

    return (
        <IframeStyle id={`${index}_${contract_type}`} scrolling="no" frameBorder="0"/>
    );
};

export default Contract;